import React from 'react';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';



const styles = theme => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1) *2
    },
    button: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    span: {
        minHeight: 60
    },
});

class ConfirmationDialog extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Typography variant="body1" gutterBottom align='center' style={{whiteSpace: 'pre-line'}}>{this.props.message}</Typography>

                <div className={classes.buttonContainer}>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={this.props.cancelHandler ? () => this.props.cancelHandler() : () => this.props.hideDialog()}>Cancelar</Button>
                    <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                        this.props.acceptHandler();
                        this.props.hideDialog();
                    }}>Aceptar</Button>
                </div>
            </div>
        );

    };

};

ConfirmationDialog.propTypes = {
    message: PropTypes.string.isRequired,
    acceptHandler: PropTypes.func.isRequired,
    cancelHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(ConfirmationDialog);